import React from 'react';

interface GlassCardProps {
    children: React.ReactNode;
    className?: string;
    hoverEffect?: boolean;
}

const GlassCard: React.FC<GlassCardProps> = ({
    children,
    className = '',
    hoverEffect = true
}) => {
    return (
        <div className={`
            glass-card border border-border rounded-3xl relative overflow-hidden bg-card/80 backdrop-blur-md shadow-md
            ${hoverEffect ? 'hover:bg-accent/10 hover:shadow-lg transition-all duration-300' : ''}
            ${className}
        `}>
            {children}
        </div>
    );
};

export default GlassCard;
